import { SidekickSupportedTms } from '@shared/generated/graphql';
import { matchDATEquipmentSearch } from 'clerk_common/constants/urls/datEquipmentSearch';
import {
  getPageHostname,
  isDomainAllowed,
} from '../page-content-permission/pageContentDomains';

export enum SupportedEntityType {
  SHIPMENT = 'shipment',
}

export const SUPPORTED_TMS_DOMAINS = {
  [SidekickSupportedTms.ALJEX]: 'aljex.com',
  [SidekickSupportedTms.LEGACY_MERCURYGATE]: 'abornandco.mercurygate.net',
  [SidekickSupportedTms.LOADSMART]: 'loadsmart.com',
  [SidekickSupportedTms.LOADSTOP]: 'loadstop.com',
  [SidekickSupportedTms.MCLEOD_WEB]: 'mcleodhosted.com',
  [SidekickSupportedTms.MERCURYGATE]: 'mercurygate.net',
  [SidekickSupportedTms.TAI]: 'taicloud.net',
  [SidekickSupportedTms.THREE_PL]: 'hyperiontms.com',
  [SidekickSupportedTms.TURVO]: 'turvo.com',
  [SidekickSupportedTms.UBER_GTG]: 'celticintl.com',
};

export const GMAIL_HOSTNAME = 'mail.google.com';

export type PageType = 'tms' | 'vooma' | 'unknown';
export type Environment = 'production' | 'staging' | 'development';

export type EntityInfo = {
  entityType: SupportedEntityType;
  entityReference: string;
};

export type TMSPageInfo = {
  pageType: 'tms';
  tms: SidekickSupportedTms;
  environment?: Environment;
  entityInfo: EntityInfo[];
};

export type VoomaPageInfo = {
  pageType: 'vooma';
  environment: Environment;
};

export type UnknownPageInfo = {
  pageType: 'unknown';
};

export type PageInfo = TMSPageInfo | VoomaPageInfo | UnknownPageInfo;

export function isTMSPageInfo(pageInfo: PageInfo): pageInfo is TMSPageInfo {
  return pageInfo.pageType === 'tms';
}

export function isGmailUrl(url: string): boolean {
  return getPageHostname(url) === GMAIL_HOSTNAME;
}

export function isAlwaysSupportedUrl(url?: string): boolean {
  if (!url) return false;

  const hostname = getPageHostname(url);
  const isTMS =
    hostname && isDomainAllowed(hostname, Object.values(SUPPORTED_TMS_DOMAINS));

  return Boolean(isTMS) || matchDATEquipmentSearch(url);
}
